// extracted by mini-css-extract-plugin
export default {"root":"NoAccessItem__root--1e-n5","hidden":"NoAccessItem__hidden--tvZml","centered":"NoAccessItem__centered--1fGjw"};